import { onError } from '@apollo/client/link/error';

import { refreshToken } from './refreshToken';

export const tokenRefreshLink = onError(({ graphQLErrors, operation, forward }) => {
  if (graphQLErrors) {
    for (let err of graphQLErrors) {
      if (err?.extensions?.code === 'UNAUTHENTICATED') {
        return refreshToken(operation, forward);
      }
    }
  }
});
